import React, { Component } from 'react';

import moment from 'moment'

var Datetime = require('react-datetime');

const ROLLING_MONTH_DAYS = 30;

class FilterDate extends Component {

  /**
   * Bornes de la période courante (aujourd'hui inclus)
   * Avec rollingMonth, "months" correspond aux 30 derniers jours au lieu du mois calendaire
   */
  static getPeriodeRange(periode, rollingMonth = false) {
    if (periode === 'months' && rollingMonth) {
      return {
        date_start: moment().subtract(ROLLING_MONTH_DAYS, 'days').startOf('day'),
        date_end: moment().endOf('day'),
      };
    }
    return {
      date_start: moment().startOf(periode),
      date_end: moment().endOf(periode),
    };
  }

  constructor(props) {
    super(props)

    moment.locale('fr');

    const periode = props.defaultPeriode ? props.defaultPeriode : 'days';
    const range = FilterDate.getPeriodeRange(periode, props.rollingMonth);

    this.state = {
      periode: periode,
      date_start: props.dateStart ? moment(props.dateStart) : range.date_start,
      date_end: props.dateEnd ? moment(props.dateEnd) : range.date_end,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      const periode = this.props.defaultPeriode ? this.props.defaultPeriode : 'days';
      this.setState({
        periode: periode,
        ...FilterDate.getPeriodeRange(periode, this.props.rollingMonth),
      });
    }
    else if(prevProps.datePeriode && prevProps.datePeriode != this.state.periode){
      this.setState({
        periode: this.props.datePeriode,
        date_start: this.props.dateStart ? this.props.dateStart : moment().startOf(this.props.datePeriode),
        date_end: this.props.dateEnd ? this.props.dateEnd : moment().endOf(this.props.datePeriode),
      })
    }
  }

  isRollingMonth() {
    return this.state.periode === 'months' && this.props.rollingMonth;
  }

  // En mois glissant, les flèches décalent la période de sa propre durée (en jours)
  shiftPeriod(direction) {
    const nbDays = moment(this.state.date_end).startOf('day').diff(moment(this.state.date_start).startOf('day'), 'days') + 1;
    this.setState({
      date_start: moment(this.state.date_start).add(direction * nbDays, 'days').startOf('day'),
      date_end: moment(this.state.date_end).add(direction * nbDays, 'days').endOf('day'),
    }, () => {
      this.props.onChangeDate(this.state.date_start, this.state.date_end)
    });
  }

  add() {
    if (this.isRollingMonth()) {
      return this.shiftPeriod(1);
    }
    this.setState({
      date_start: moment(this.state.date_start).add(1, this.state.periode).startOf(this.state.periode),
      date_end: moment(this.state.date_start).add(1, this.state.periode).endOf(this.state.periode),
    }, () => {
      this.props.onChangeDate(this.state.date_start, this.state.date_end)
    });
  }

  subtract() {
    if (this.isRollingMonth()) {
      return this.shiftPeriod(-1);
    }
    this.setState({
      date_start: moment(this.state.date_start).subtract(1, this.state.periode).startOf(this.state.periode),
      date_end: moment(this.state.date_start).subtract(1, this.state.periode).endOf(this.state.periode),
    }, () => {
      this.props.onChangeDate(this.state.date_start, this.state.date_end)
    });
  }

  onChangeDateStart(date_start) {
    this.setState({
      date_start: moment(date_start).startOf('day'),
    }, () => {
      this.props.onChangeDate(this.state.date_start, this.state.date_end)
    });
  }

  onChangeDateEnd(date_end) {
    this.setState({
      date_end: moment(date_end).endOf('day'),
    }, () => {
      this.props.onChangeDate(this.state.date_start, this.state.date_end)
    });
  }

  // maxRange (optionnel) : durée maximale de la période, au format moment (ex : { years: 1 })
  isValidDateStart(current) {
    if (!this.props.maxRange) {
      return true;
    }
    return current.isAfter(moment(this.state.date_end).subtract(this.props.maxRange), 'day');
  }

  isValidDateEnd(current) {
    if (!this.props.maxRange) {
      return true;
    }
    return current.isBefore(moment(this.state.date_start).add(this.props.maxRange), 'day');
  }

  handleClickPeriode(event) {

    var periode = event.target.value;

    var date_start = moment();
    var date_end = moment();

    if (periode === 'weeks') {
      date_start = date_start.startOf('weeks')
      date_end = date_end.endOf('weeks')
    }
    else if (periode === 'months') {
      ({ date_start, date_end } = FilterDate.getPeriodeRange('months', this.props.rollingMonth));
    }

    this.setState({
      periode: periode,
      date_start: date_start,
      date_end: date_end,
    }, () => {
      this.props.onChangeDate(this.state.date_start, this.state.date_end, this.state.periode)
    });
  }

  render() {
    return (
      <div className={this.props.className}>

          <div className="btn-group pull-left" style={{ display: 'inline-block', paddingTop: 1, marginRight: '30px' }}>
            <button className={this.state.periode === 'days' ? 'btn btn-primary active' : 'btn btn-primary'} type="button" value="days" onClick={this.handleClickPeriode.bind(this)}>Jour</button>
            <button className={this.state.periode === 'weeks' ? 'btn btn-primary active' : 'btn btn-primary'} type="button" value="weeks" onClick={this.handleClickPeriode.bind(this)}>Semaine</button>
            <button className={this.state.periode === 'months' ? 'btn btn-primary active' : 'btn btn-primary'} type="button" value="months" onClick={this.handleClickPeriode.bind(this)}>Mois</button>
          </div>

          <div className='pull-left'>
            <div className='form-group pull-left' style={{ display: 'inline-block', height: '26px' }}>
              <a style={{ marginRight: 5 }} onClick={this.subtract.bind(this)}>
                <i className="fa fa-chevron-left" aria-hidden="true" style={{ verticalAlign: 'bottom' }}></i>
              </a>
            </div>

            <div className='form-group' style={{ width: 110, display: 'inline-block', }}>
              <Datetime
                  className="datetime"
                  locale="fr"
                  closeOnSelect={true}
                  timeFormat={false}
                  value={this.state.date_start.format('L')}
                  onChange={this.onChangeDateStart.bind(this)}
                  isValidDate={this.isValidDateStart.bind(this)}
                  inputProps={{
                      readOnly: true,
                      style: { cursor: "pointer" }
                  }}
              />
            </div>
            &nbsp;
            <div className='form-group' style={{ width: 110, display: 'inline-block', }}>
              <Datetime
                  className="datetime"
                  locale="fr"
                  closeOnSelect={true}
                  timeFormat={false}
                  value={this.state.date_end.format('L')}
                  onChange={this.onChangeDateEnd.bind(this)}
                  isValidDate={this.isValidDateEnd.bind(this)}
                  inputProps={{
                      readOnly: true,
                      style: { cursor: "pointer" }
                  }}
              />
            </div>

            <div className='form-group pull-right' style={{ display: 'inline-block', height: '26px' }}>
              <a style={{ marginLeft: 5 }} onClick={this.add.bind(this)}>
                <i className="fa fa-chevron-right" aria-hidden="true" style={{ verticalAlign: 'bottom' }}></i>
              </a>
            </div>
          </div>

          <div className='clearfix' />

      </div>
    );
  }
}

export default FilterDate;
